import MainLayout from '../../layouts/MainLayout';
import React from 'react';
import RequireAuth from '../../guards/RequireAuth';
import { Route } from 'react-router';
import List from './List';

const Routes = (
  <Route
    path="/locations"
    element={
      <RequireAuth>
        <MainLayout />
      </RequireAuth>
    }
  >
    <Route path="/locations" element={<List />} />
  </Route>
);

export default Routes;
